import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Resets route navigation to the top while preserving deliberate in-page anchor navigation. */
export default function RouteScrollManager(): null {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));

      if (target) {
        target.scrollIntoView();
        return;
      }
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [pathname, hash]);

  return null;
}
